var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isOnPrem
        ? _c(
            "va-card",
            [
              _c("div", { staticClass: "va-title" }, [
                _vm._v(_vm._s(_vm.$t("licensesList.newTitle")))
              ]),
              _c("v-file-input", {
                ref: "licenseUploader",
                attrs: {
                  accept: ".lic",
                  label: "License file",
                  variant: "outlined"
                },
                model: {
                  value: _vm.fileLicense,
                  callback: function($$v) {
                    _vm.fileLicense = $$v
                  },
                  expression: "fileLicense"
                }
              }),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c("va-button", {
                    staticClass: "mr-4",
                    attrs: {
                      color: "secondary",
                      type: "outline",
                      loading: _vm.$store.getters["onprem/loading"],
                      cta: _vm.$t("common.dismiss")
                    },
                    on: { click: _vm.onDismiss }
                  }),
                  _c("va-button", {
                    attrs: {
                      loading: _vm.$store.getters["onprem/loading"],
                      cta: _vm.$t("common.submit")
                    },
                    on: { click: _vm.onUpload }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c(
            "va-card",
            [
              _c("div", { staticClass: "va-title" }, [
                _vm._v(_vm._s(_vm.$t("licensesList.newTitle")))
              ]),
              _c(
                "v-form",
                {
                  ref: "newLicenseForm",
                  attrs: { "lazy-validation": "", onSubmit: "return false;" },
                  on: { submit: _vm.onSave },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c("va-text-field", {
                    staticClass: "mb-4",
                    attrs: {
                      rules: [_vm.required],
                      label: _vm.$t("common.key")
                    },
                    model: {
                      value: _vm.newLicense.licenseKey,
                      callback: function($$v) {
                        _vm.$set(_vm.newLicense, "licenseKey", $$v)
                      },
                      expression: "newLicense.licenseKey"
                    }
                  }),
                  _c("va-switch", {
                    attrs: { text: _vm.$t("licensesList.renew") },
                    model: {
                      value: _vm.newLicense.isRenewal,
                      callback: function($$v) {
                        _vm.$set(_vm.newLicense, "isRenewal", $$v)
                      },
                      expression: "newLicense.isRenewal"
                    }
                  }),
                  _vm.newLicense.isRenewal
                    ? _c("va-text-field", {
                        staticClass: "mb-4",
                        attrs: {
                          rules: [_vm.required],
                          label: _vm.$t("licensesList.oldKey")
                        },
                        model: {
                          value: _vm.newLicense.licenseKeyToRenew,
                          callback: function($$v) {
                            _vm.$set(_vm.newLicense, "licenseKeyToRenew", $$v)
                          },
                          expression: "newLicense.licenseKeyToRenew"
                        }
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "text-right" },
                    [
                      _c("va-button", {
                        staticClass: "mr-4",
                        attrs: {
                          color: "secondary",
                          type: "outline",
                          loading: _vm.$store.getters["license/isLoading"],
                          cta: _vm.$t("common.dismiss")
                        },
                        on: { click: _vm.onDismiss }
                      }),
                      _c("va-button", {
                        attrs: {
                          submit: "",
                          disabled: !_vm.valid,
                          loading: _vm.$store.getters["license/isLoading"],
                          cta: _vm.$t("common.submit")
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }